import {Component, Input} from '@angular/core';
import {Quiz} from '../../../types/quiz';
import {QuestionPreviewService} from '../../../question-preview.service';

@Component({
    selector: 'app-true-false-question-preview',
    templateUrl: './true-false-question-preview.component.html',
    styleUrls: ['./true-false-question-preview.component.scss'],
    standalone: false
})
export class TrueFalseQuestionPreviewComponent {
    @Input({required: true})
    public questionPreview!: Quiz;

    @Input()
    public type: 'full' | 'basic' | undefined;

    constructor(public questionPreviewService: QuestionPreviewService) {
    }
}
